/**
 * @file collector-card.component.ts
 * Carte de rareté COLLECTOR — rareté maximale.
 *
 * Effets visuels :
 * - Dégradé rouge cramoisi (#f87171 → #ef4444 → #fca5a5)
 * - Bordure animée en rotation rouge vif
 * - Particules rouges ascendantes
 * - Paillettes montantes scintillantes
 * - Couche d'étincelles cross color-dodge
 * - Effets de foudre animés sur canvas 2D (CardLightningEffect)
 *
 * Usage :
 * ```html
 * <app-collector-card [card]="cardData" />
 * ```
 */

import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import {Card} from '@/app/shared/components/card/card.model';
import {CardComponent} from '@/app/shared/components/card/card.component';

@Component({
  selector: 'app-collector-card',
  standalone: true,
  imports: [CardComponent],
  template: `
    <app-card
      rarity="COLLECTOR"
      [name]="card.name"
      [score]="score"
      [rating]="card.rating"
      [image]="card.fileName"
      [backOfCard]="card.extension.cardBack"
      [extensionId]="card.extension.id"
      [initiallyFlipped]="initiallyFlipped"
      [interactive]="interactive"
      [author]="card.author"
    />
  `,
  host: { style: 'display: block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectorCardComponent {
  /** Données complètes de la carte à afficher. */
  @Input({ required: true }) card!: Card;

  /** Score obtenu pour ce tirage — propre à l'instance, pas à la carte. */
  @Input({ required: true }) score!: number;

  /** Si `true`, la carte démarre côté dos. */
  @Input() initiallyFlipped = false;

  /**
   * Si `false`, désactive le tilt souris + halo hover interne de `CardComponent`.
   * Utile quand le survol/zoom est déjà géré par un composant parent
   * (ex. `CardsLayerComponent.enableHoverZoom()` dans l'ouverture de booster),
   * pour éviter deux systèmes de hover concurrents sur le même élément.
   */
  @Input() interactive = true;
}
